<div class="px-lg py-base rounded-sm flex items-center bg-error text-white">
  <div class="flex mr-sm">
    <svg-icon key="warning-diamond" class="!text-base"></svg-icon>
  </div>
  <div class="flex-1 text-base leading-base text-white">{{ errorMessage }}</div>
</div>
